import type {
	CreateShopDisapprovalReasonDto,
	ShopDto,
} from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useAddDisapprovalReason(shop: ShopDto) {
	return useApiMutation("post", "/shops/{shopId}/disapproval-reasons", {
		invalidate: useInvalidateShop(shop.id),
		mapVariables: (variables: CreateShopDisapprovalReasonDto) => ({
			params: { path: { shopId: shop.id } },
			body: variables,
		}),
	});
}
